export default defineNuxtRouteMiddleware((to, from) => {
    useNuxtApp().$scrollToTop(true);
});
